<template>
  <b-row align-h="center">
    <b-col v-if="noResult" md="10" lg="8" xl="6">
      <div class="noresult align-items-center justify-content-center py-5">
        <img
          src="https://cdn.vexels.com/img/search-woman.png"
          :alt="$t('withoutResult.main.wildcard.seekerManAlt')"
          loading="lazy"
          width="250"
          height="250"
        />
        <div class="text-container">
          <p v-if="inSortPage">
            {{ $t('withoutResult.main.noResult.noMatchFound') }}
          </p>
          <p v-else>
            {{ $t('withoutResult.main.noResult.notFoundTextBefore') }}
            <span style="color: #000000">"{{ actualSearch }}"</span>
            {{ $t('withoutResult.main.noResult.notFoundTextAfter') }}
          </p>
        </div>
      </div>

      <FindBestDesignsBlocks />
      <BestCategories />
    </b-col>
  </b-row>
</template>

<script>
import FindBestDesignsBlocks from '@/components/Common/FindBestDesignsBlocks';
import BestCategories from '@/components/Common/BestCategories';
export default {
  components: {
    FindBestDesignsBlocks,
    BestCategories
  },
  props: {
    inSortPage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    actualSearch() {
      return this.$route.params.search ? this.$route.params.search.replace(/-/g, ' ') : '';
    },
    noResult() {
      return (
        this.$store.state.search.searchResult.length == 0 && !this.$store.state.search.searching
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.noresult {
  margin: auto;
  transition: 0.5s width;
  display: flex;
}
.noresult img {
  width: 40%;
  height: auto;
}
.noresult .text-container {
  width: 48%;
  padding-left: 50px;
}
.noresult .text-container p {
  font-size: 30px;
  color: #989898;
}
.noresult .text-container p a {
  color: #3cd699;
}
.vx-btn {
  border-radius: 50px;
  height: max-content;
  margin: auto;
}
@media all and (max-width: $screen-sm-min) {
  .noresult .text-container {
    padding: 0 0 0 50px;
  }
  .noresult .text-container p {
    font-size: 25px;
  }
}
@media all and (max-width: $screen-lg-min) {
  .noresult .text-container p {
    font-size: 20px;
  }
}
@media all and (max-width: $screen-md-min) {
  .noresult {
    display: block;
    text-align: center;
  }
  .noresult .text-container {
    padding: 0;
    margin: auto;
    margin-top: 25px;
    text-align: left;
  }
}
@media all and (max-width: $screen-sm-min) {
  .noresult .text-container {
    width: 95%;
  }
  .noresult img {
    width: 60%;
  }
}
@media all and (max-width: $screen-xs-min) {
  .noresult img {
    width: 90%;
  }
}
</style>
